<template>
	<div class="search">
		<navtop></navtop>
		<ul class="resList">
			<li v-on:click="checkLogin(roomInfo.roomId)">
				<img  v-bind:src="roomInfo.roomPic"/>
				<div class="info">
					<p>{{roomInfo.roomName}}</p>
					<span>房间ID:{{roomInfo.roomid||roomInfo.roomId}}</span>
				</div>
				<i class="iconfont">&#xe667;</i>
			</li>
		</ul>
		<!--<navbottom></navbottom>-->
	</div>
</template>

<script>
	import navtop from '../dating/navTop'
	import navbottom from '../dating/navBottom'
	import passPort from '../../libs/passport'
	import cookie from '../../libs/cookie'
	import { mapState } from 'vuex'

	export default {
		name: 'index',
		data() {
			return {
				roomInfo: '',
				roomId:'',
			}
		},
		components: {
			navtop,
			navbottom
		},
		computed: mapState(
			[
				'searchRoomId',
			]
		),
		mounted() {
			this.roomId=this.searchRoomId||cookie.get('searchRoomId')
			if(/^[2]\d{5}$/ig.test(this.roomId)){
				this.checkRoomId();
			}else if(/^[34]\d{5}$/ig.test(this.roomId)){
				this.checkAnchorId();
			}
		},
		methods:{
			checkLogin(roomId){
				if(passPort.isLogin()) {
					location.href= location.protocol + "//h5.qxiu.com/room.html?roomid="+roomId+ "&channelid=" +cookie.get('channelid')
				}else{
					this.$store.commit('getCurview', 'loginmode')
					location.hash='/'
				}
			},
			checkRoomId(){
				if(this.roomId) {
					var _this=this
					$.ajax({
						type: "get",
						url: "https://api.qxiu.com/op-api/room_pic_info?id="+this.roomId,
						async: true,
						dataType: "jsonp",
						success: function(res) {
							if(res.result&&(res.result.data.result == 0)) {
								_this.roomInfo=res.result.data
							}else{
								alert("该房间不存在")
								location.hash="/"
							}
						}
					});
				}
			},
			checkAnchorId(){
				if(this.roomId) {
					var _this=this
					$.ajax({
						type: "get",
						url: "https://datacenter.qxiu.com/cgi/anchor/micInfo?anchorIds=["+ _this.roomId +"]",
						async: true,
						dataType: "jsonp",
						success: function(res) {
							if(res.result&&res.result.mics&&res.result.mics[_this.roomId]){
								var roomid = res.result.mics[_this.roomId].roomId + '';
								if(/^[1]{6}/gi.test(roomid)){
									roomid = roomid.slice(1)
								}
								_this.roomInfo = {
									roomId: roomid,
									roomName: roomid,
									roomPic: 'https://static.qxiu.com/h5/img/static/default2.png'
								}
							}else{
								_this.roomInfo = {
									roomId: '1'+ _this.roomId,
									roomid: _this.roomId,
									roomName: _this.roomId,
									roomPic: 'https://static.qxiu.com/h5/img/static/default2.png'
								}
							}
						}
					});
				}
			}
		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	.resList {
		margin-top: 1.76rem;
		background: #fff;
		min-height: 22rem;
	}
	
	.resList li {
		padding: 0.4rem;
		overflow: hidden;
	}
	
	.resList li:not(:first-child) {
		border-top: 1px solid #DFDFDF;
	}
	
	.resList li img {
		float: left;
		width: 2.4rem;
		height: 2.4rem;
		border-radius: 50%;
	}
	
	.resList li>i {
		float: right;
		line-height: 2.4rem;
		margin-right: 1rem;
	}
	
	.info {
		float: left;
		padding-top: 0.56rem;
		padding-left: 0.6rem;
		vertical-align: middle;
	}
	
	.info p {
		font-size: 0.56rem;
	}
	
	.info p span {
		margin-left: 0.2rem;
	}
	
	.info>span {
		font-size: 0.48rem;
		color: #999;
	}
</style>


// WEBPACK FOOTER //
// search.vue?4b91f579